import { Box, IconButton, Portal, Tooltip } from '@chakra-ui/react';
import { ReactComponent as DownloadIcon } from 'assets/icons/download.svg';
import { OPEN_SHARE_MODAL } from 'constants/mixpanel';
import { Mixpanel } from 'libs/third-party/Mixpanel/mixpanel';
import { useAppDispatch } from 'modules/Editor/store';
import { setDownloadModal } from 'modules/Editor/store/editorSettingsSlice';
import { DownloadModalTrigger } from 'modules/Editor/store/editorSettingsSlice.types';
import { ReactElement, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { DownloadModal } from './components/DownloadModal';

export const DownloadMenu = memo((): ReactElement => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('common_navbar');

  const handleOpenModal = () => {
    dispatch(setDownloadModal({ isOpen: true, trigger: DownloadModalTrigger.Navbar }));
    Mixpanel.track(OPEN_SHARE_MODAL.eventName, {
      from: OPEN_SHARE_MODAL.from.DownloadButton,
    });
  };

  const label = t('navbar.download-menu-label');
  const testId = 'download-infograph-button';
  const tooltipLabel = t('navbar.download-button');

  return (
    <Box ml='auto'>
      <Tooltip label={tooltipLabel} placement='bottom' bg='black' hasArrow>
        <IconButton
          variant='ghost'
          size='sm'
          data-testid={testId}
          aria-label={label}
          icon={<DownloadIcon color='var(--vg-colors-font-500)' width={20} height={20} />}
          onClick={handleOpenModal}
        />
      </Tooltip>
      <Portal>
        <DownloadModal />
      </Portal>
    </Box>
  );
});
DownloadMenu.displayName = 'DownloadMenu';
